// extracted by mini-css-extract-plugin
export default {"noBackground":"Sda-z","qnaContainer":"Tda-z","qna":"Uda-z","question":"Vda-z","modal":"Wda-z"};